import { useEffect, useState } from 'react';

import { onPremEnabled } from 'src/utils/utils';

/**
 * Whether this is an on-prem deployment: REACT_APP_ON_PREM_ENABLED from manifest.json,
 * falling back to the build-time env var.
 *
 * @returns {boolean | null} null on the first render and until the check resolves;
 * it always resolves to true or false
 */
export default function useIsOnPremDeployment (): boolean | null {
  const [isOnPrem, setIsOnPrem] = useState<boolean | null>(null);

  useEffect(() => {
    onPremEnabled().then(setIsOnPrem);
  }, []);

  return isOnPrem;
}
